import { api, headersConfig } from "../../services/api";

const stone_service_path = '/stones.php';
const stone_variations_service_path = '/stone-variations.php';

export async function getStones() {

    const response = await api.get(stone_service_path, headersConfig);

    return response;
};


export async function getStoneVariations(variation) {

    const response = await api.get(`${stone_variations_service_path}?variation=${variation}`, headersConfig);

    return response;
};
